import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

let echoInstance = null;

function getToken() {
  try {
    const raw = localStorage.getItem("authUser");
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed?.access_token || null;
    }
  } catch {
    // ignore parse errors
  }
  return null;
}

export function getEcho() {
  if (echoInstance) return echoInstance;

  const key = process.env.REACT_APP_REVERB_KEY;
  const host = process.env.REACT_APP_REVERB_HOST || window.location.hostname;
  const port = process.env.REACT_APP_REVERB_PORT || 8080;
  const scheme = process.env.REACT_APP_REVERB_SCHEME || "http";

  if (!key) return null;

  echoInstance = new Echo({
    broadcaster: "reverb",
    key,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint: "/api/broadcasting/auth",
    auth: {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    },
  });

  return echoInstance;
}

export function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}
